import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, useNavigate, useLocation, Navigate } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { useEffect } from "react";
import Index from "./pages/Index";
import About from "./pages/About";
import Services from "./pages/Services";
import Testimonials from "./pages/Testimonials";
import Pickleball from "./pages/Pickleball";
import PickleballParadox from "./pages/PickleballParadox";
import Privacy from "./pages/Privacy";
import TermsOfService from "./pages/TermsOfService";
import FullyHuman from "./pages/FullyHuman";
import ForOrganizations from "./pages/ForOrganizations";
import AITransition from "./pages/AITransition";
import Essays from "./pages/Essays";
import TheHumanLoop from "./pages/essays/TheHumanLoop";
import TheSpaceBetween from "./pages/essays/TheSpaceBetween";
import NotFound from "./pages/NotFound";

const queryClient = new QueryClient();

// Handles ?route=<path> redirects coming from the static OG-tag landing pages
// (public/pickleballparadox.html, public/fully-human.html) used for link previews.
const ShareRedirectHandler = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== "/") return;
    const params = new URLSearchParams(location.search);
    const route = params.get("route");
    if (route) {
      navigate("/" + route.replace(/^\/+/, ""), { replace: true });
    }
  }, [location, navigate]);

  return null;
};

const App = () => (
  <HelmetProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ShareRedirectHandler />
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/testimonials" element={<Testimonials />} />
            <Route path="/pickleball" element={<Pickleball />} />
            <Route path="/pickleballparadox" element={<PickleballParadox />} />
            <Route path="/fully-human" element={<FullyHuman />} />
            <Route path="/for-organizations" element={<ForOrganizations />} />
            <Route path="/ai-transformation" element={<AITransition />} />
            <Route path="/ai-transition" element={<Navigate to="/ai-transformation" replace />} />
            <Route path="/essays" element={<Essays />} />
            <Route path="/essays/the-human-loop" element={<TheHumanLoop />} />
            <Route path="/essays/the-second-loop" element={<Navigate to="/essays/the-human-loop" replace />} />
            <Route path="/essays/the-space-between" element={<TheSpaceBetween />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<TermsOfService />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </HelmetProvider>
);

export default App;
